// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"65861fd8","74":"dc5690fc","80":"a3ae62ab","121":"1a667b31","243":"761a844f","277":"353acc62","336":"ac7a6f15","376":"c271eb2f","428":"c98650fb","482":"7d983e4d","570":"e4d977c0","713":"9dde4793","861":"01495c29","995":"90cc3297"}[chunkId] + ".chunk.js";
};